import React from "react";
import { MyBtnCheckActive } from "../UI/MyBtnCheckActive";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import { observer } from "mobx-react-lite";
import stateFilter from "../../state/state.filter";
import Media from "../../api/Media";

export const VisibleActiveSoft = observer((props) => {
  if (props.v4Layout) {
    return (
      <>
        <CcV4Toggle
          label={
            !Media.mobile ? "Софт с лицензией" : "Софт с лицензией"
          }
          active={stateFilter.filter_active_client}
          onClick={props.onClickActive}
        />
        <CcV4Toggle
          label={
            !Media.mobile ? "Только сервер (SRV)" : "Только сервер"
          }
          active={stateFilter.filter_active_server}
          onClick={props.onClickServer}
        />
      </>
    );
  }

  return (
    <div className="card-flex-container">
      <div className="checkbox_active_client text_soft_filter_version">
        {!Media.mobile ? "Софт с лицензией" : "Активные"}
        <MyBtnCheckActive
          active={stateFilter.filter_active_client}
          onClick={props.onClickActive}
        />
      </div>
      <div className="checkbox_active_client text_soft_filter_version">
        {!Media.mobile ? "Только сервер" : "сервер"}
        <MyBtnCheckActive
          active={stateFilter.filter_active_server}
          onClick={props.onClickServer}
        />
      </div>
    </div>
  );
});
